export default "__VITE_ASSET__BCmGp2wY__"